import { createSlice } from '@reduxjs/toolkit';

// Multi-company support for CUSTOM-plan accounts — one login can own
// several fully-isolated companies (Phase 5). Populated on login when the
// auth response includes `owned_companies` (only set for accounts with a
// customer_account_id, i.e. an approved Custom plan).
const initialState = {
  ownedCompanies: [],   // [{ id, name, slug, logo_url, plan }]
  activeCompanyId: null,
};

const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    setOwnedCompanies: (state, action) => {
      state.ownedCompanies = action.payload || [];
    },
    setActiveCompanyId: (state, action) => {
      state.activeCompanyId = action.payload;
    },
    clearWorkspace: () => ({ ...initialState }),
  },
});

export const { setOwnedCompanies, setActiveCompanyId, clearWorkspace } = workspaceSlice.actions;
export default workspaceSlice.reducer;

export const selectOwnedCompanies = (state) => state.workspace.ownedCompanies;
export const selectActiveCompanyId = (state) => state.workspace.activeCompanyId;
export const selectHasMultipleCompanies = (state) => state.workspace.ownedCompanies.length > 1;
